import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
const documentDomain = import.meta.env.VITE_DOMAIN;
const initialState = {
  restricted: null,
  status: "idle",
};

export const fetchConfig = createAsyncThunk(
  "config/fetchConfig",
  async ({ controller, scope }, { rejectWithValue }) => {
    try {
      const link = `${documentDomain}/${controller}/${scope}/ui_config.json`;
      const res = await axios.get(link, {
        headers: {
          "Content-Type": "text/html",
        },
      });
      return res.data;
    } catch (e) {
      try {
        const link = `${documentDomain}/${controller}/ui_config.json`;
        const res = await axios.get(link, {
          headers: {
            "Content-Type": "text/html",
          },
        });
        return res.data;
      } catch (e) {
        return rejectWithValue(e);
      }
    }
  }
);

const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchConfig.pending, (state) => {
        state.status = "loading";
        state.restricted = null;
      })
      .addCase(fetchConfig.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.restricted = action?.payload?.restricted;
      })
      .addCase(fetchConfig.rejected, (state, action) => {
        state.status = "failed";
      });
  },
});

export const isPageRestricted = (state, page) =>
  state?.restricted?.pages?.includes(page);
export const isActionRestricted = (state, action) =>
  state?.restricted?.actions?.includes(action);
export const isFieldRestricted = (state, field) =>
  state?.restricted?.fields?.includes(field);

export default configSlice.reducer;
